import { useEffect, useState } from "react";
import Modal from "../Common/modal";
import QuoteModal from "./quoteModal";
import RequestInformationForm from "./requestInformationForm";
import { useNavigate } from "react-router-dom";

const Enquire = ({ setOpenEnquire = () => {} }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openInfo, setOpenInfo] = useState(false);
  const navigate = useNavigate();

  return (
    <div>
      <h3 className="text-center">Are you interested in knowing more?</h3>
      <p className="text-center">
        TeknèItalia Products are the result of years of listening and taking
        care of your needs. Do not hesitate to get in touch with us.
      </p>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
        {/* First Button */}
        <button
          type="button"
          onClick={() => {
            navigate("/quote");
            setOpenEnquire(false);
            // setIsModalOpen(true);
          }}
          className=" bg-orange-600 hover:bg-orange-700 text-white font-medium px-6 py-2 rounded"
        >
          Request Quote
        </button>

        {/* Second Button */}
        <button
          type="button"
          onClick={() => {
            navigate("/information");
            setOpenEnquire(false);

            // setOpenInfo(true);
          }}
          className="bg-orange-600 hover:bg-orange-700 text-white font-medium px-6 py-2 rounded"
        >
          Request Information
        </button>
      </div>

      {/* Modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setOpenEnquire(false);
        }}
      >
        <QuoteModal />
      </Modal>

      <Modal
        isOpen={openInfo}
        onClose={() => {
          setOpenInfo(false);
          setOpenEnquire(false);
        }}
      >
        <RequestInformationForm />
      </Modal>
    </div>
  );
};
export default Enquire;
